module.exports = __webpack_public_path__ + "static/pic2-8dd82453db105af6999ee8862f2739fe.jpg";